/**
 *
 * @param  {string} messageValue
 * @param  {string} param
 * @param  {string} replace
 * @constructor
 */
const PreperatorReplace = (messageValue = '', param = '', replace = '') =>{

    let replaceString = messageValue.replaceAll(param, replace)

    return replaceString;

}

export default PreperatorReplace;
